import React from 'react';
import PropTypes from 'prop-types';
import { Typo } from 'uikit/content';
import { CardContent } from 'uikit/cards';
import { Skeleton } from 'uikit/loaders';

import styles from '../styles/videosAdminMetricsCardRow.module.scss';

const VideosAdminMetricsCardRow = ({ metrics }) => (
  <div className={styles.element}>
    {metrics.map(({ id, name, value }) => (
      <CardContent key={id} className={styles.card}>
        <div className={styles.cardContent}>
          {value === undefined ? (
            <Skeleton height={45} width={100} />
          ) : (
            <Typo element="h2">{value}</Typo>
          )}
        </div>
        <Typo element="p" variant="s03">{name}</Typo>
      </CardContent>
    ))}
  </div>
);

VideosAdminMetricsCardRow.propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
  })).isRequired,
};

export default React.memo(VideosAdminMetricsCardRow);
